// src/components/LogoutComponent.tsx
import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

const LogoutComponent: React.FC = () => {
    const { logout } = useAuth();

    useEffect(() => {
        // Call the logout function
        logout();
        // Redirect to the login page after logout
        //navigate('/login'); // Adjust the path based on your login route
    }, [logout]);

    return null; // No UI is required for this component
};

export default LogoutComponent;
